/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { Component } from 'react';

class Links extends Component {
  onPress = () => {
    this.props.onPressItem(this.props.item, this.props.id);
  }

  render() {
    const { item, selected } = this.props;

    return (
      <li
        className={selected ? 'active' : ''}
        onClick={this.onPress}
      >
        {item}
      </li>
    );
  }
}

export default Links;
